import axios from 'axios';
import { api, googleApi } from '../../utils/Constants';
import { updateAxiosToken } from './apiService';


export async function getDistanceMatrix (actualCoordinates, destCoordinates) {
  await updateAxiosToken();

  const url = `${api.url}${googleApi.methods.distancematrix}`;
  const params = {
    origins: `${actualCoordinates.lat},${actualCoordinates.lon}`,
    destinations: `${destCoordinates.lat},${destCoordinates.lon}`
  };

  const response = await axios.get(url, { params : params });

  return response.data;
}
